<template>
  <div name="config-change-trend-wrapper">
    <div
      name="period-picker"
      class="d-flex justify-content-end align-items-center mr-2"
    >
      <span class="mr-2">Duration</span>
      <div class="custom-selector-width">
        <atom-select
          v-model="selectedDuration"
          label="name"
          placeholder="Select Duration"
          :isClearable="false"
          :isAppendToBody="false"
          :isEnableProper="false"
          :option="durationOptions"
        ></atom-select>
      </div>
    </div>
    <b-card class="m-2">
      <div class="card__header d-flex flex-column">
        <span class="header__label">Configuration Change Trend</span>
        <span class="subheader__label">{{ datePeriod }}</span>
      </div>
      <div class="mt-2">
        <molecule-config-change-line-chart
          :dataset="configChangeTrendDataSet"
        ></molecule-config-change-line-chart>
      </div>
    </b-card>
  </div>
</template>

<script>
import { BCard } from "bootstrap-vue"
import AtomSelect from "@/components/atoms/AtomSelect.vue"
import AtomLineChart from "@/components/atoms/graphs/AtomLineChart.vue"
import MoleculeConfigChangeLineChart from "@/components/molecules/networkConfigurationManagement/MoleculeConfigChangeLineChart.vue"
import { DateTime } from "luxon"
export default {
  name: "MoleculeConfigChangeTrend",
  components: {
    AtomSelect,
    AtomLineChart,
    BCard,
    MoleculeConfigChangeLineChart,
  },
  props: {
    configChangeTrendDataSet: {
      type: Array,
      required: false,
      default: () => [],
    },
  },
  data() {
    return {
      durationOptions: [
        {
          name: "30 Days",
          value: 30,
        },
        {
          name: "3 Months (90 Days)",
          value: 90,
        },
        {
          name: "6 Months (180 Days)",
          value: 180,
        },
        {
          name: "1 Year (365 Days)",
          value: 365,
        },
        {
          name: "3 Year (1095 Days)",
          value: 1095,
        },
        {
          name: "5 Year (1825 Days)",
          value: 1825,
        },
      ],
      selectedDuration: {
        name: "30 Days",
        value: 30,
      },
    }
  },
  computed: {
    datePeriod() {
      let dateStart = DateTime.now()
        .startOf("day")
        .minus({ days: this.selectedDuration.value })
        .toFormat("dd MMMM yyyy")
      let dateEnd = DateTime.now().startOf("day").toFormat("dd MMMM yyyy")
      return `${dateStart} - ${dateEnd}`
    },
  },
  watch: {
    selectedDuration: {
      deep: true,
      handler() {
        this.$emit("onUpdateSelectedDuration", this.selectedDuration)
      },
    },
  },
}
</script>

<style lang="scss" scoped>
.custom-selector-width {
  width: 210px;
}

.header__label {
  font-weight: 500;
  font-size: 18px;
  color: #5e5873;
}
</style>
